import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Section } from '../components/ui/Section';
import { ArrowLeft } from 'lucide-react';
export function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-screen w-full bg-[#0f0f23] text-[#f5f0e8] font-sans selection:bg-[#c9a96e] selection:text-[#0f0f23] py-12" data-id="element-268">
      <div className="max-w-3xl mx-auto px-6" data-id="element-269">
        <Link to="/" className="inline-flex items-center text-[#c9a96e] hover:text-[#d4b479] transition-colors mb-8 font-medium" data-id="element-270">
          <ArrowLeft size={20} className="mr-2" data-id="element-271" />
          Back to Home
        </Link>

        <Section className="!py-0" data-id="element-272">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#faf6f0] mb-8" data-id="element-273">
            Terms of Service
          </h1>
          <p className="text-[#d4cfc5] mb-12 italic" data-id="element-274">
            Last updated: February 2026
          </p>

          <div className="space-y-8 text-lg text-[#f5f0e8] leading-relaxed" data-id="element-275">
            <section data-id="element-276">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-277">
                1. Introduction
              </h2>
              <p data-id="element-278">
                Welcome to Better By Steps. By purchasing "Baby Only Sleeps In
                My Arms — Emergency Night Protocol" (the "Product"), you agree
                to these Terms of Service. Please read them carefully.
              </p>
            </section>

            <section data-id="element-279">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-280">
                2. Digital Product Delivery
              </h2>
              <p data-id="element-281">
                This is a digital product delivered via instant PDF download.
                Upon purchase, you will receive an email with a link to download
                your copy. No physical product will be shipped.
              </p>
            </section>

            <section data-id="element-282">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-283">
                3. Refund Policy
              </h2>
              <p data-id="element-284">
                We offer a 3-night money-back guarantee. If you run the protocol
                for 3 nights and do not see progress, you may request a full
                refund by emailing us at hello@betterbysteps.com. Refunds are
                processed within 5-7 business days.
              </p>
            </section>

            <section data-id="element-285">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-286">
                4. Intellectual Property
              </h2>
              <p data-id="element-287">
                All content included in the Product, such as text, graphics,
                logos, and images, is the property of Better By Steps and
                protected by copyright laws. You may not redistribute, resell,
                or share the Product with others. Your purchase grants you a
                single-user license for personal use only.
              </p>
            </section>

            <section data-id="element-288">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-289">
                5. Limitation of Liability
              </h2>
              <p data-id="element-290">
                The Product is for informational purposes only and does not
                constitute medical advice. Always consult your pediatrician or
                healthcare provider about your baby's sleep and safety. Better
                By Steps is not liable for any direct, indirect, incidental, or
                consequential damages arising from your use of the Product.
              </p>
            </section>

            <section data-id="element-291">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-292">
                6. Governing Law
              </h2>
              <p data-id="element-293">
                These Terms shall be governed by and defined following the laws
                of the United States. Better By Steps and yourself irrevocably
                consent that the courts of the United States shall have
                exclusive jurisdiction to resolve any dispute which may arise in
                connection with these terms.
              </p>
            </section>

            <section data-id="element-294">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-295">
                7. Contact Us
              </h2>
              <p data-id="element-296">
                If you have any questions about these Terms, please contact us
                at hello@betterbysteps.com.
              </p>
            </section>
          </div>
        </Section>
      </div>
    </main>;
}